var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOral(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2,0,0,2,0,0)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:inherit;stroke-linecap:round;stroke-linejoin:round;}")), /*#__PURE__*/React.createElement("title", null, "online-learning-online-course-3"), /*#__PURE__*/React.createElement("path", {
    d: "M10.25,12.886h2.542V16.75l4.416-3.864h4.747A1.545,1.545,0,0,0,23.5,11.341v-9.3A1.545,1.545,0,0,0,21.955.5H8.045A1.545,1.545,0,0,0,6.5,2.045V9.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "13.087 10 13.087 3.608 18.413 6.804 13.087 10"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 14.5,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5,23.5a4.5,4.5,0,0,0-9,0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOral);
export default __webpack_public_path__ + "static/media/oral.27b664c9.svg";
export { ForwardRef as ReactComponent };